module.exports = __webpack_public_path__ + "img/icon_member.92937256.svg";